import { useId, type ReactNode } from "react";

type Props = { label: string; title: string; intro: string; items: readonly { title: string; text: string }[]; children?: ReactNode };

/** A focused decision section, distinct from the numbered service journey. */
export default function SelectionGuide({ label, title, intro, items, children }: Props) {
  const headingId = useId();
  return <section className="design-selection-guide" aria-labelledby={headingId}>
    <div className="max-w-[1400px] mx-auto">
      <header className="design-selection-heading">
        <div><p className="text-brand-label">{label}</p><h2 id={headingId}>{title}</h2></div>
        <p>{intro}</p>
      </header>
      <div className="design-selection-options">
        {items.map(item => <article key={item.title}><h3>{item.title}</h3><p>{item.text}</p></article>)}
      </div>
      {children && <div className="design-selection-action">{children}</div>}
    </div>
  </section>;
}
